// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__jdSvM","noInteraction":"EventWrapper_noInteraction__SsaKq","pointerPassthrough":"EventWrapper_pointerPassthrough__3dJza"};